"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.howYouHeardAboutUsLabels = exports.ContactPreference = void 0;
var ContactPreference = /** @class */ (function () {
    function ContactPreference() {
        this.email = false;
        this.sms = false;
        this.phone = false;
        this.post = false;
    }
    return ContactPreference;
}());
exports.ContactPreference = ContactPreference;
exports.howYouHeardAboutUsLabels = {
    14: "Action Cancer Event",
    17: "Action Cancer House",
    21: "Action Cacner Shop",
    9: "App",
    6: "Big Bus",
    19: "Facebook",
    25: "Family History Clinic",
    12: "Flag Day",
    11: "Flyer",
    24: "Genetic Referral",
    26: "Genetics Clinic",
    10: "Gordon's Chemist",
    22: "Health Professional",
    7: "Letter",
    3: "Newspaper",
    16: "Outdoor poster",
    2: "Radio Advert",
    15: "Radio Interview",
    23: "Supervalu",
    20: "talkSPORT",
    8: "T/S letter",
    13: "Through organisation",
    1: "TV",
    4: "Website",
    5: "Word of Mouth",
    18: "Other",
};
//# sourceMappingURL=ContactPreference.js.map